interface SubscriptionGateProps {
  children: React.ReactNode;
}

// Pagos deshabilitados temporalmente: no mostramos banners de prueba,
// past_due, cancelación ni pantallas de upgrade. Solo renderizamos los hijos.
const SubscriptionGate = ({ children }: SubscriptionGateProps) => {
  return <>{children}</>;
};

export default SubscriptionGate;
